// @flow

import React from 'react';
import {
  Banner,
  Box,
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { AsyncBox } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import { formatDateDisplayUTC } from '@fortress-technology-solutions/fortress-component-library/utils/index';
import useIntl from '../../../hooks/useIntl';
import type { Step2Props } from './types';
import messages from './messages';
import { useStep2 } from './Step2.hooks';
import Step2Table from './Step2Table';

const Step2 = (step2Props: Step2Props) => {
  const intl = useIntl();
  const { isEditMode } = step2Props;
  const { changedRows, effectiveDate, grossRentCertExistsForYear, isLoading } =
    useStep2(step2Props);

  const formattedEffectiveDate = effectiveDate
    ? formatDateDisplayUTC(effectiveDate, 'MM/DD/YYYY')
    : '';

  return (
    <Stack spacing={1.5}>
      <AsyncBox loading={isLoading} sx={{ minHeight: 80 }}>
        <Step2Table rows={changedRows} />
      </AsyncBox>

      <Typography variant="bodyMedium">
        {intl.formatMessage(
          isEditMode
            ? messages.editConfirmationPrompt
            : messages.confirmationPrompt,
          {
            effectiveDate: formattedEffectiveDate,
          },
        )}
      </Typography>

      <Banner
        status={isEditMode ? 'warning' : 'info'}
        title={intl.formatMessage(messages.savingChangesTitle)}
        message={
          <Box component="ul" sx={{ m: 0, pl: 2.5, mt: 0.5 }}>
            <Box component="li">
              {intl.formatMessage(
                isEditMode
                  ? messages.editSavingChangesUpdateAmounts
                  : messages.savingChangesUpdateAmounts,
              )}
            </Box>
            <Box component="li">
              {intl.formatMessage(
                isEditMode
                  ? messages.editSavingChangesUpdateCertifications
                  : messages.savingChangesCreateCertifications,
              )}
            </Box>
          </Box>
        }
      />

      {grossRentCertExistsForYear ? (
        <Banner
          status="warning"
          message={intl.formatMessage(messages.grossRentCertExistsWarning)}
        />
      ) : null}
    </Stack>
  );
};

export default Step2;
